import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import UserRoleList from "../../components/RolePermission/UserRoleList";
const UserRoleListPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <UserRoleList/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};
export default UserRoleListPage;